import React from "react";
import { Box, Center, Grid, Heading, Image, Text } from "@chakra-ui/react";
import flowerImage from "../../../assets/home/flowerr.png";
import yellowCardImage from "../../../assets/home/yellowc.png";
import paajiImage from "../../../assets/home/paji.png";
import cream from "../../../assets/flower/cream.png";
import grey from "../../../assets/flower/greyish.png";
import red from "../../../assets/flower/redd.png";
import FlowerImage from "component/FlowerImage";
import Card from "./Card";
import gray from "assets/home/card/gray.png";
import lightgreen from "assets/home/card/lightgreen.svg";
import sky from "assets/home/card/sky.png";

const Whydoggle = () => {
  const partner = [
    {
      title: "User Focus  ",
      description:
        " We don't just create good products, we craft the best products for your customers quickly and creatively",
      image: lightgreen,
    },
    {
      title: "Agile Approach  ",
      description: "New milestones every week, solutions for every challenge—ensuring smooth progress!",
      image: gray,
    },
    {
      title: "End-to-End Delivery  ",
      description: " From brainstorming to execution, we stand by you every step of the way.",
      image: sky,
    },
    {
      title: "Value Adding  ",
      description: " Simple and smart solutions that drive the right growth for your business!",
      image: sky,
    },
  ];

  return (
    <Box position="relative" bg="#F9E8D4" py={{ base: 8, md: 16 }}>
      <FlowerImage
        src={grey}
        top={{ base: "14%", md: "25%" }}
        left={{ base: "14%", md: "30%" }}
      />
      <FlowerImage
        src={red}
        top={{ base: "45%", md: "88%" }}
        left={{ base: "5%", md: "20%" }}
      />
      <FlowerImage
        src={cream}
        top={{ base: "97%", md: "95%" }}
        right={{ base: "2%", md: "30%" }}
      />

      {/* Background flower image */}
      <Image
        src={flowerImage}
        alt="Flower"
        position="absolute"
        top={{ base: "3%", md: "15%" }}
        left="50%"
        transform="translate(-50%, -50%)"
        boxSize={{ base: "80px", md: "180px" }}
        zIndex={0}
        opacity={7}
      />

      {/* Main Heading */}
      <Center flexDirection="column" textAlign="center" zIndex={1} mb={12}>
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          className="fade-in-up"
        >
          Our approach
        </Heading>
        <Text
          as="span"
          fontSize={{ base: "md", md: "xl" }}
          color="gray.600"
          mt={2}
          className="fade-in-up"
        >
          <Text as="em" className="fade-in-up">
            Innovation aur Focus
          </Text>{" "}
          ke saath,
        </Text>
      </Center>

      {/* Grid Layout */}
      <Grid
        py={{ base: 12, md: 12 }}
        templateColumns={{
          base: "1fr",
          sm: "repeat(2, 1fr)",
          lg: "repeat(4, 1fr)",
        }}
        gap={6}
        px={{ base: 4, md: 12 }}
      >
        {partner.map((service, index) => (
          <Card
            key={index}
            service={service}
            cardwidth={"250px"}
            index={index}
          />
        ))}
      </Grid>

      {/* Decorative Elements */}
      <Image
        src={yellowCardImage}
        alt="Yellow Card"
        position="absolute"
        top={{ base: "5%", md: "10%" }}
        right={{ base: "10%", md: "28%" }}
        height={{ base: "60px", md: "100px" }}
        width={"148px"}
        zIndex={1}
      />
      <Image
        src={paajiImage}
        alt="Paaji Character"
        position="absolute"
        bottom={{ base: "5%", md: "10%" }}
        right={{ base: "10%", md: "15%" }}
        boxSize={{ base: "80px", md: "120px" }}
        zIndex={1}
        data-animated="true"
      />
    </Box>
  );
};

export default Whydoggle;
